import Bouncer from "formbouncerjs";
import messages from "./messages";

export default new (class Validator {
    /**
     * Validator constructor
     */
    constructor() {
        this.bouncer = null;

        this.init();
    }

    /**
     * Init validator
     */
    init() {
        this.bouncer = new Bouncer("._form-validation", {
            disableSubmit: true,
            messages: messages.ro,
            customValidations: {
                alphanumeric: function (field) {
                    const rules = field.getAttribute("data-rules");
                    let result = false;

                    if (!rules || !field.value) {
                        return result;
                    }

                    const ruleList = rules.split("|");

                    ruleList.forEach((rule) => {
                        const regex = /^[A-Za-z0-9\'\-\.,\săâîșțĂÎÂȘȚ!?]+$/;

                        if (
                            rule === "alphanumeric" &&
                            !regex.test(field.value.trim())
                        ) {
                            result = true;
                        }
                    });

                    return result;
                },
            },
        });

        document.addEventListener("bouncerFormValid", ({ target }) => {
            target.classList.remove("_form-error");
        });

        document.addEventListener("bouncerFormInvalid", ({ target }) => {
            target.classList.add("_form-error");
        });
    }

    /**
     * @param {HTMLFormElement} form
     * @return {boolean}
     */
    isNotValid(form) {
        return form.classList.contains("_form-error");
    }

    /**
     * Get bouncer
     * @return {object}
     */
    getBouncer() {
        return this.bouncer;
    }
})();
